<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App',
    mounted() {
      // let agoraScript = document.createElement('script');
      // agoraScript.setAttribute('src', '/agora/agora-uikit.js');
      // document.head.appendChild(agoraScript);
      // this.$intercom.boot();
    }
  }
</script>

<style lang="scss">
  @import 'assets/fontawesome/scss/fontawesome';
  @import 'assets/fontawesome/scss/brands';
  @import 'assets/fontawesome/scss/regular';
  @import 'assets/fontawesome/scss/light';
  @import 'assets/fontawesome/scss/solid';

  @import 'assets/webfontkit/webfont';

  @import 'assets/scss/main';

  html, body {
    margin: 0;
    padding: 0;
    width: 100%;
    min-height: 100vh;

    #app {
      font-family: 'sf_pro_displaysemibold';
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      height: 100%;
    }

    .swal2-select {
      font-size: 1em;
      outline: 0;
      border-color: $linkWater;
      border-radius: 4px;
    }

    @media (min-width: 1200px) {
      .container {
        max-width: 100%;
      }
    }
  }
</style>
